import { render } from "./saudesocial.vue?vue&type=template&id=469c57a0"
import script from "./saudesocial.vue?vue&type=script&lang=js"
export * from "./saudesocial.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__